import React from "react";
import { useHistory } from "react-router-dom";
import "./sidebar.css";
import logoutIcon from "../../img/logout.png";
import userIcon from "../../img/user.png";
import carIcon from "../../img/Tanker management.png";
import vendorIcon from "../../img/vendor1.png";
import siteIcon from "../../img/site1.png";
import routeIcon from "../../img/route.png";
import tripIcon from "../../img/trip.png";
import dashboardIcon from "../../img/dashboard.png";
import reportIcon from "../../img/report.png";
import GpsIcon from "../../img/GPS report.png";
import RunningIcon from "../../img/Running Report.png";
import StoppageIcon from "../../img/Stoppage report.png";
import AllTripIcon from "../../img/All trip report.png";
import SummaryIcon from "../../img/GPS Report.png";
import DelayedIcon from "../../img/Delayed report.png";
import TemparingIcon from "../../img/Tempering report.png";
import OverSpeedIcon from "../../img/Over speed report.png";
import NearestVehicleIcon from "../../img/Nearest vehicle report.png";
import RouteDevationIcon from "../../img/Route Deviation report.png";
import TrackHistoryIcon from "../../img/trackhistory.png";
import fuelDashboardIcon from "../../img/fueldashboard.png";
import fuelIcon from "../../img/FuelReport.png";
import fuelFillIcon from "../../img/Fuelfillreport.png";
import fuelDroppageIcon from "../../img/Fueldroppagereport.png";
import fuelmanagementIcon from "../../img/fuelmanagement.png";
import activeLogIcon from "../../img/Activelog.svg";
import activeRouteIcon from "../../img/ActiveRoutes.png";
import uptimeIcon from "../../img/Uptimereport.png";
import zoneIcon from "../../img/Zone management.png";
import fplIcon from "../../img/Fpl.png";
import deliveryIcon from "../../img/Delivery Management.png";
import emergencyIcon from "../../img/Emergency management.png";
import tripdashboard from "../../img/Tripdashboard.png";
import tripschedule from "../../img/Trip schedule.png";
import GPSdetail from "../../img/GPS detail.png";
import CompleteTrip from "../../img/GPS Report.png";
import MissedApprovalTrip from "../../img/GPS Report.png";
import MissedTrip from "../../img/GPS Report.png";
import priceIcon from "../../img/Price master MNGMT.png";
import emergencyIcon1 from "../../img/Emergency.png";
import agencyIcon from "../../img/Agency.png";
import tankerIcon from "../../img/Tanker.png";
import DriverIcon from "../../img/Driver.png";
import palentyIcon from "../../img/Penalty.png";
import updateDistanceIcon from "../../img/Update Distance.png";
import wardManagementIcon from "../../img/WardManagement.png";
import OperationDashboard from "../../img/operation-dashboard.png";
import tripScheduleIcon from "../../img/Trip Schedule.svg";
import dplManagementIcon from "../../img/DPL management.svg";
import StatisticsIcon from "../../img/Analytics.png"
import PerformaceIcon from "../../img/performance-up-graph-svgrepo-com.svg"

import { vehicleName, siteName, agencyName } from "../../config/config";
import {
  decryptAes,
  decryptAesObj,
} from "../CommonComponents/AESencryptdecrypt";
import axios from "axios";

function Sidebar() {
  const history = useHistory();
  const [permissionAccess, setPermissionAccess] = React.useState(
    decryptAesObj(localStorage?.getItem("data")),
  );
  console.log("permissionAccess: ", permissionAccess);
  const viewAllUserPermission =
    permissionAccess &&
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order?.name === "USER_MENU",
    );
  const viewAllSitePermission =
    permissionAccess &&
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order?.name === "SITE_MENU",
    );
  const viewAllEmergencyPermission =
    permissionAccess &&
    permissionAccess.webPermissionDTOList.filter(
      (order) => order?.name === "EMERGENCY_MENU",
    );
  const viewAllRoutePermission =
    permissionAccess &&
    permissionAccess.webPermissionDTOList.filter(
      (order) => order?.name === "ROUTE_MENU",
    );
  const viewAllVehiclePermission =
    permissionAccess &&
    permissionAccess.webPermissionDTOList.filter(
      (order) => order.name === "VEHICLE_MENU",
    );
  const viewAllVendorPermission =
    permissionAccess &&
    permissionAccess.webPermissionDTOList.filter(
      (order) => order.name === "VENDOR_MENU",
    );

  console.log("viewAllVendorPermission", viewAllVendorPermission);
  // const viewAllZonePermission = permissionAccess && permissionAccess.webPermissionDTOList.filter(order => (order.name === "Zone_MENU"));
  const viewAllTripPermission =
    permissionAccess &&
    permissionAccess.webPermissionDTOList.filter(
      (order) => order.name === "GET_ALL_TRIP",
    );
  // console.log(viewAllTripPermission.length);
  // const viewAllTripSchedulePermission = permissionAccess && permissionAccess.webPermissionDTOList.filter(order => (order.name === "GET_ALL_TRIP_SCHEDULE"));
  const viewAllReportPermission =
    permissionAccess &&
    permissionAccess.webPermissionDTOList.filter(
      (order) => order.name === "GET_ALL_REPORT",
    );
  const viewAllReportAuditPermission =
    permissionAccess &&
    permissionAccess.webPermissionDTOList.filter(
      (order) => order.name === "GET_AUDIT_LOG_REPORT",
    );
  const viewAllReportActiveRoutesPermission =
    permissionAccess &&
    permissionAccess.webPermissionDTOList.filter(
      (order) => order.name === "GET_ACTIVE_ROUTES",
    );
  const viewAllUpdateDistancePermission =
    permissionAccess &&
    permissionAccess?.menuVisiblity?.filter(
      (order) => order?.name === "GET_UPDATE_DISTANCE",
    );
  console.log(viewAllUpdateDistancePermission);

  // trip management submenu visibility
  let viewAllTripSubMenuPermission;
  if (permissionAccess && permissionAccess?.subMenuVisibilty) {
    viewAllTripSubMenuPermission =
      permissionAccess &&
      permissionAccess?.subMenuVisibilty.filter(
        (order) => order?.menuName === "TRIP_MANAGEMENT",
      );
  }

  console.log("viewAllTripSubMenuPermission", viewAllTripSubMenuPermission);

  let viewAllReportsSubMenuPermission;
  // report submenu visibility

  if (permissionAccess && permissionAccess?.subMenuVisibilty) {
    viewAllReportsSubMenuPermission =
      permissionAccess &&
      permissionAccess?.subMenuVisibilty.filter(
        (order) => order?.menuName === "REPORTS",
      );
  }

  //   let dashboardMenu = true;
  //   let userMenu = true;
  //   let vendorMenu = true;
  //   let vehicleMenu = true;
  //   let siteMenu = true;
  //   let emergencyMenu = true;
  //   let zoneMenu = true;
  //   let routeMenu = true;
  //   let trackMenu = true;
  //   let tripMenu = true;
  //   let tripscheduleMenu = true;
  //   let reportMenu = true;
  //   let fuelMenu = true;

  let dashboardMenu = true; //done
  let userMenu = true; //done
  let vendorMenu = true; //done
  let vehicleMenu = true; //done
  let siteMenu = true; //done
  let routeMenu = true; //done
  let trackMenu = true; //done
  let tripMenu = true; //done
  let fuelMenu = true; //done
  let reportMenu = true; //done

  let gpsMenu = true; //done
  let constituencyMenu = true; //done
  let updateDistance = true; //done
  let emergencyMenu = true; // only show site Management
  let WardManagementMenu = false;
  let zoneMenu = true; //done
  let fplMenu = true; //done
  let deliveryMenu = true; //done
  let priceMasterMenu = true; //done
  let appovalMenu = true; //done
  // let tripscheduleMenu = true;
  let operationsDashboard = false;
  let tokenManagement = false;
  let analyticsDashboard = false

  // submenus
  let tripDashboard = true;
  let disengargedTrip = false;
  let tripAllocationReport = true;
  let missedTripApproval = true;
  let missedTripReport = true;
  let completedTripReport = true;
  let gpsTrips = true;
  let distanceReport = true;
  let DisengargedDailyReports = true;
  let emergencyPerformanceReport = true;
  let agencyPerformanceReport = true;
  let tankerPerformanceReport = true;
  let driverPerformanceReport = true;
  let penaltyReport = true;
  let tamperingReport = true;
  let inactiveVehicleReport = true;
  let summaryReport = true;
  let gpsReport = true;
  let ShedInOutReport = true;
  let duplicateReports = true;
  let dplManagement = false;
  let scheduleManagement = true;
  let tripSchedulelist = true;
  let divisionList = true;
  let masterTripScheduleList = true;
  let AssemblyList = true;
  let logReport = true;

  if (permissionAccess?.menuVisiblity) {
    permissionAccess?.menuVisiblity?.forEach((element) => {
      if (element.name == "DASHBOARD") {
        dashboardMenu = element.isVisible;
      }
      if (element.name == "OPERATION_DASHBOARD") {
        // operationsDashboard = element.isVisible;
      }

      if (element.name == "USER_MANAGEMENT") {
        userMenu = element.isVisible;
      }
      if (element.name == "TRANSPORTER_MANAGEMENT") {
        vendorMenu = element.isVisible;
      }
      if (element.name == "VEHICLE_MANAGEMENT") {
        vehicleMenu = element.isVisible;
      }
      if (element.name == "SITE_MANAGEMENT") {
        siteMenu = element.isVisible;
      }

      if (element.name == "ROUTE_MANAGEMENT") {
        routeMenu = element.isVisible;
      }
      if (element.name == "TRACK_HISTORY") {
        trackMenu = element.isVisible;
      }
      if (element.name == "TRIP_MANAGEMENT") {
        tripMenu = element.isVisible;
      }

      if (element.name == "FUEL_MANAGEMENT") {
        fuelMenu = element.isVisible;
      }
      if (element.name == "REPORTS") {
        reportMenu = element.isVisible;
      }
      if (element.name == "GPS_MANAGEMENT") {
        gpsMenu = element.isVisible;
      }
      if (element.name == "CONSTITUENCY_MANAGEMENT") {
        constituencyMenu = element.isVisible;
      }
      if (element.name == "GET_UPDATE_DISTANCE") {
        updateDistance = element.isVisible;
      }
      if (element.name == "EMERGENCY_MANAGEMENT") {
        emergencyMenu = element.isVisible;
      }
      if (element.name == "WARD_MANAGEMENT") {
        WardManagementMenu = element.isVisible;
      }
      if (element.name == "FPL_MANAGEMENT") {
        fplMenu = element.isVisible;
      }
      if (element.name == "DELIVERY_MANAGEMENT") {
        deliveryMenu = element.isVisible;
      }
      if (element.name == "PRICE_MASTER_MANAGEMENT") {
        priceMasterMenu = element.isVisible;
      }
      if (element.name == "PRIOR_APPROVAL_MANAGEMENT") {
        appovalMenu = element.isVisible;
      }
      if (element.name == "ZONE_MANAGEMENT") {
        zoneMenu = element.isVisible;
      }
      if (element.name == "DPL_MANAGEMENT") {
        dplManagement = element.isVisible;
      }
      if (element.name == "SCHEDULE_MANAGEMENT") {
        scheduleManagement = element.isVisible;
      }
      if (element.name == "TRIP_SCHEDULE") {
        tripSchedulelist = element?.isVisible;
      }
      if (element.name == "MASTER_TRIP_SCHEDULE_LIST") {
        masterTripScheduleList = element.isVisible;
      }
      if (element.name == "ASSEMBLY_MANAGEMENT") {
        AssemblyList = element.isVisible;
      }
      if (element.name == "DIVISION_MANAGEMENT") {
        divisionList = element.isVisible;
      }

      if (element.name == "TOKEN_MANAGEMENT") {
        tokenManagement = element.isVisible;
      }
      if (element.name == "ANALYTICS_DASHBOARD") {
        analyticsDashboard = element.isVisible;
      }

    });
  }

  // submenu

  if (permissionAccess?.subMenuVisibilty) {
    permissionAccess?.subMenuVisibilty?.forEach((element) => {
      if (element.name === "TRIP_DASHBOARD") {
        tripDashboard = element.isVisible;
      }
      if (element.name === "DISENGAGED_TRIP") {
        disengargedTrip = element.isVisible;
      }
      if (element.name === "TRIP_ALLOCATION_REPORT") {
        tripAllocationReport = element.isVisible;
      }
      if (element.name === "MISSED_TRIP_APPROVAL") {
        missedTripApproval = element.isVisible;
      }
      if (element.name === "MISSED_TRIP_REPORT") {
        missedTripReport = element.isVisible;
      }
      if (element.name === "COMPLETED_TRIP_REPORT") {
        completedTripReport = element.isVisible;
      }
      if (element.name === "GPS_TRIPS") {
        gpsTrips = element.isVisible;
      }
      if (element.name === "EMERGENCY_PERFORMANCE_REPORT") {
        emergencyPerformanceReport = element.isVisible;
      }
      if (element.name === "AGENCY_PERFORMANCE_REPORT") {
        agencyPerformanceReport = element.isVisible;
      }
      if (element.name === "TANKER_PERFORMANCE_REPORT") {
        tankerPerformanceReport = element.isVisible;
      }
      if (element.name === "DRIVER_PERFORMANCE_REPORT") {
        driverPerformanceReport = element.isVisible;
      }
      if (element.name === "PENALTY_REPORT") {
        penaltyReport = element.isVisible;
      }
      if (element.name === "TAMPERING_REPORT") {
        tamperingReport = element.isVisible;
      }
      if (element.name === "INACTIVE_VEHICLE_REPORT") {
        inactiveVehicleReport = element.isVisible;
      }
      if (element.name === "SUMMARY_REPORT") {
        summaryReport = element.isVisible;
      }
      if (element.name === "DUPLICATE_REPORT") {
        duplicateReports = element.isVisible;
      }

      if (element.name === "DISTANCE_REPORT") {
        distanceReport = element.isVisible;
      }
      if (element.name === "DISENGAGED_DAILY_REPORTS") {
        DisengargedDailyReports = element.isVisible;
      }

      if (element.name === "GPS_REPORT") {
        gpsReport = element.isVisible;
      }
      if (element.name === "LOG_REPORT") {
        logReport = element.isVisible;
      }
    });
  }


  const handleLogout = async () => {
    window.open(`/`, "_self");
    window.clear();
  };

  // const baseUrl = `${window.location.protocol}//${window.location.host}/`;  // Adjust '/api' if necessary
  // const documentType = 'text/html; charset=utf-8'; // Example: PDF document

  const handleClick = (value) => {
    history.push(`/${value}`);
    window.open(`/${value}`, "_self");
    window.location.reload();
  };
  const safeString = (value) => {
    if (typeof value === "string") return value;
    if (value && typeof value === "object" && value.name) return value.name;
    return "";
  };

  const emailDecrypted = decryptAes(localStorage.getItem("email"));
  const dataDecrypted = decryptAesObj(localStorage.getItem("data"));

  

  const showPerfMenu = (dataDecrypted.email === "ceodelhi.djb@nic.in" || dataDecrypted.email === "ccr.djb1@gmail.com" || dataDecrypted.email === "parveen_james@yahoo.com")


  return (
    <div className="sidebar">
      {emailDecrypted !== "route" && dataDecrypted?.userType !== "VENDOR" ? (
        <div className="top-menu">
          {operationsDashboard && (
            <div
              className="navlink "
              onClick={() => handleClick("operations-dashboard")}
            >
              <div style={{ width: "20px" }}>
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ==
                        "operations-dashboard"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={OperationDashboard}
                  alt="User"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Operations Dashboard{" "}
              </div>
            </div>
          )}
          {dashboardMenu && (
            <div className="navlink " onClick={() => handleClick("dashboard")}>
              <div style={{ width: "20px" }}>
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "dashboard"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={dashboardIcon}
                  alt="User"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Dashboard{" "}
              </div>
            </div>
          )}
          {analyticsDashboard && (
            <div
              className="navlink "
              onClick={() => handleClick("analytics-dashboard")}
            >
              <div style={{ width: "20px" }}>
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ==
                        "analytics-dashboard"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={StatisticsIcon}
                  alt="User"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Analytics Dashboard{" "}
              </div>
            </div>
          )}
          {gpsMenu && (
            <div className="navlink " onClick={() => handleClick("gpslist")}>
              <div style={{ width: "20px" }}>
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "gpslist"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={dashboardIcon}
                  alt="User"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Gps Management{" "}
              </div>
            </div>
          )}
          {viewAllUserPermission.length > 0 && userMenu && (
            <div className="navlink " onClick={() => handleClick("userlist")}>
              <div style={{ width: "20px" }}>
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "userlist"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={userIcon}
                  alt="User"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                User Management{" "}
              </div>
            </div>
          )}
          {viewAllVendorPermission.length > 0 && zoneMenu && (
            <div className="navlink " onClick={() => handleClick("zonelist")}>
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "zonelist"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1 "
                  src={zoneIcon}
                  alt="Zone"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Circle Management{" "}
              </div>
            </div>
          )}
          {(siteMenu || emergencyMenu) && (
            <div
              className="navlink "
              onClick={() => handleClick("emergencylist")}
            >
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "emergencylist"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-0 pl-1"
                  src={emergencyIcon}
                  alt="emergency"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Emergency Management{" "}
              </div>
            </div>
          )}

          {WardManagementMenu && (
            <div className="navlink " onClick={() => handleClick("wardlist")}>
              <div style={{ width: "20px" }}>
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "wardlist"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-0 pl-1"
                  src={wardManagementIcon}
                  alt="ward"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Ward Management
              </div>
            </div>
          )}

          {viewAllSitePermission.length > 0 && constituencyMenu && (
            <div
              className="navlink "
              onClick={() => handleClick("constituencyList")}
            >
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ==
                        "constituencyList"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-0 pl-1"
                  src={emergencyIcon}
                  alt="emergency"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Constituency Management{" "}
              </div>
            </div>
          )}
          {viewAllVendorPermission?.length > 0 && vendorMenu && (
            <div
              className="navlink "
              onClick={() => handleClick("transporterlist")}
            >
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname?.split("/")[1] ==
                        "transporterlist"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={vendorIcon}
                  alt="Transporter"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                {/* {agencyName} Management{" "} */}
                {safeString(agencyName)} Management
              </div>
            </div>
          )}
          {viewAllVehiclePermission?.length > 0 && vehicleMenu && (
            <div
              className="navlink "
              onClick={() => handleClick("vehiclelist")}
            >
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "vehiclelist"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={carIcon}
                  alt="vehicle"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                {/* {vehicleName} Management{" "} */}
                {safeString(vehicleName)} Management
              </div>
            </div>
          )}

          {viewAllSitePermission.length > 0 && fplMenu && (
            <div className="navlink " onClick={() => handleClick("fpllist")}>
              <div style={{ width: "20px" }}>
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "fpllist"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1 pl-1"
                  src={fplIcon}
                  alt="site"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                FPL Management{" "}
              </div>
            </div>
          )}

          {viewAllSitePermission.length > 0 && deliveryMenu && (
            <div
              className="navlink "
              onClick={() => handleClick("deliverylist")}
            >
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "deliverylist"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-0 pl-1"
                  src={deliveryIcon}
                  alt="site"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Delivery Management{" "}
              </div>
            </div>
          )}

          {dplManagement && (
            <div
              className="navlink"
              onClick={() => handleClick("dplManagement")}
            >
              <div style={{ width: "20px" }}>
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] === "dplManagement"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-0 pl-1"
                  src={dplManagementIcon}
                  alt="site"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                DPL Management
              </div>
            </div>
          )}

          {dataDecrypted.userType === "ADMIN" && (
            <div
              className="navlink"
              onClick={() => handleClick("schedule-master")}
            >
              <div style={{ width: "20px" }}>
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] === "schedule-master"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-0 pl-1"
                  src={tripScheduleIcon}
                  alt="site"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Schedule Master
              </div>
            </div>
          )}

          {(dataDecrypted.userType === "ADMIN" || showPerfMenu) && (
            <div
              className="navlink"
              onClick={() => handleClick("performance-score")}
            >
              <div style={{ width: "20px" }}>
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] === "performance-score"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-0 pl-1"
                  src={PerformaceIcon}
                  alt="site"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Performance Score
              </div>
            </div>
          )}


          {/*  */}


          {viewAllVendorPermission?.length > 0 && tripSchedulelist && (
            <div
              className="navlink "
              onClick={() => handleClick("tripSchedule")}
            >
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "tripSchedule"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-0 pl-1"
                  src={tripScheduleIcon}
                  alt="site"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Trip Schedule{" "}
              </div>
            </div>
          )}

          {viewAllVendorPermission?.length > 0 && masterTripScheduleList && (
            <div
              className="navlink "
              onClick={() => handleClick("tripScheduleLists")}
            >
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ==
                        "tripScheduleLists"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-0 pl-1"
                  src={tripScheduleIcon}
                  alt="site"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Trip Schedule List{" "}
              </div>
            </div>
          )}
          {viewAllVendorPermission?.length > 0 && AssemblyList && (
            <div
              className="navlink "
              onClick={() => handleClick("depotlist?type=assembly")}
            >
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "divisonList"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-0 pl-1"
                  src={deliveryIcon}
                  alt="site"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Assembly Management{" "}
              </div>
            </div>
          )}
          {viewAllVendorPermission?.length > 0 && divisionList && (
            <div
              className="navlink "
              onClick={() => handleClick("divisonList")}
            >
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "divisonList"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-0 pl-1"
                  src={deliveryIcon}
                  alt="site"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Division Management{" "}
              </div>
            </div>
          )}

          {viewAllRoutePermission.length > 0 && routeMenu && (
            <div
              className="navlink fuelDashboard"
              onClick={() => handleClick("routelist")}
            >
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "routelist"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={routeIcon}
                  alt="route"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Route Management{" "}
              </div>
            </div>
          )}

          {/* {viewAllRoutePermission.length > 0 && fuelMenu && (
              <div
                className="navlink "
                onClick={() => handleClick("fuelDashboard")}
              >
                <div style={{ width: "20px" }}>
                  {" "}
                  <img
                    style={{
                      opacity:
                        window.location.pathname.split("/")[1] == "routelist"
                          ? 1
                          : 0.5,
                      width: "30px",
                    }}
                    className="ml-1"
                    src={routeIcon}
                    alt="route"
                  />
                </div>
                <div className="text-white ml-2 font-weight-bolder">
                  Fuel Management{" "}
                </div>
              </div>
            
            )} */}

          {/* ====================================UPDATE DISTANCE=========================================== */}

          {viewAllUpdateDistancePermission.length > 0 && updateDistance && (
            <div
              className="navlink "
              onClick={() => handleClick("updateDistance")}
            >
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "updateDistance"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={updateDistanceIcon}
                  alt="route"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Update Distance{" "}
              </div>
            </div>
          )}
          {/* ===================================END========================================== */}
          {trackMenu && (
            <div className="navlink " onClick={() => handleClick("history/0")}>
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "history"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={TrackHistoryIcon}
                  alt="route"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Track History{" "}
              </div>
            </div>
          )}

          {viewAllRoutePermission.length > 0 && priceMasterMenu && (
            <div className="navlink " onClick={() => handleClick("agreement")}>
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "agreement"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={priceIcon}
                  alt="route"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Price Master Management{" "}
              </div>
            </div>
          )}

          {viewAllTripPermission?.length > 0 && appovalMenu && (
            <div
              className="navlink "
              onClick={() => handleClick("preApprovalList")}
            >
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ==
                        "preApprovalList"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={tripIcon}
                  alt="route"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Prior Approval Management{" "}
              </div>
            </div>
          )}

          {viewAllTripPermission.length > 0 && tripMenu && (
            <div className="navlink dropdown">
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "tripStatus"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={tripIcon}
                  alt="route"
                />
              </div>

              <div className="text-white ml-2 font-weight-bolder">
                Trip Management
              </div>
            </div>
          )}

          {/* ==================TRIP MANAGEMENT SUBMENU ========================== */}

          {viewAllTripSubMenuPermission?.length > 0 && (
            <div className="showDivReport1">
              {tripDashboard && (
                <div
                  className="navlink pl-4"
                  onClick={() =>
                    handleClick(
                      permissionAccess?.companyId == "5"
                        ? "tripslist"
                        : "tripStatus",
                    )
                  }
                >
                  <div style={{ width: "20px" }}>
                    {" "}
                    <img
                      style={{
                        opacity:
                          window.location.pathname.split("/")[1] == "tripStatus"
                            ? 1
                            : 0.5,
                        width: "30px",
                      }}
                      className="ml-1"
                      src={tripdashboard}
                      alt="route"
                    />
                  </div>
                  <div className="text-white ml-2 font-weight-bolder">
                    Trip Dashboard{" "}
                  </div>
                </div>
              )}

              {disengargedTrip && (
                <div
                  className="navlink pl-4"
                  onClick={() =>
                    handleClick(
                      permissionAccess?.companyId == "5"
                        ? "DisengagedTrip"
                        : "tripStatus",
                    )
                  }
                >
                  <div style={{ width: "20px" }}>
                    {" "}
                    <img
                      style={{
                        opacity:
                          window.location.pathname.split("/")[1] == "tripStatus"
                            ? 1
                            : 0.5,
                        width: "30px",
                      }}
                      className="ml-1"
                      src={tripdashboard}
                      alt="route"
                    />
                  </div>
                  <div className="text-white ml-2 font-weight-bolder">
                    Disengaged Trip Dashboard{" "}
                  </div>
                </div>
              )}

              {permissionAccess?.companyId != "5" && (
                <>
                  {tripAllocationReport && (
                    <div
                      className="navlink pl-4"
                      onClick={() => handleClick("tripSchedulelist")}
                    >
                      <div style={{ width: "20px" }}>
                        {" "}
                        <img
                          style={{
                            opacity:
                              window.location.pathname.split("/")[1] ==
                                "tripSchedulelist"
                                ? 1
                                : 0.5,
                            width: "30px",
                          }}
                          className="ml-1"
                          src={tripschedule}
                          alt="route"
                        />
                      </div>
                      <div className="text-white ml-2 font-weight-bolder">
                        Trip Allocation Report{" "}
                      </div>
                    </div>
                  )}

                  {missedTripApproval && (
                    <div
                      className="navlink pl-4"
                      onClick={() => handleClick("missedTripApproval")}
                    >
                      <div style={{ width: "20px" }}>
                        {" "}
                        <img
                          style={{
                            opacity:
                              window.location.pathname.split("/")[1] ==
                                "missedTripApproval"
                                ? 1
                                : 0.5,
                            width: "30px",
                          }}
                          className="ml-1"
                          src={MissedApprovalTrip}
                          alt="route"
                        />
                      </div>
                      <div className="text-white ml-2 font-weight-bolder">
                        Missed Trip Approval
                      </div>
                    </div>
                  )}

                  {missedTripReport && (
                    <div
                      className="navlink pl-4"
                      onClick={() => handleClick("missedTrips")}
                    >
                      <div style={{ width: "20px" }}>
                        {" "}
                        <img
                          style={{
                            opacity:
                              window.location.pathname.split("/")[1] ==
                                "missedTrips"
                                ? 1
                                : 0.5,
                            width: "30px",
                          }}
                          className="ml-1"
                          src={MissedTrip}
                          alt="route"
                        />
                      </div>
                      <div className="text-white ml-2 font-weight-bolder">
                        Missed Trip Report
                      </div>
                    </div>
                  )}

                  {completedTripReport && (
                    <div
                      className="navlink pl-4"
                      onClick={() => handleClick("completedTrips")}
                    >
                      <div style={{ width: "20px" }}>
                        {" "}
                        <img
                          style={{
                            opacity:
                              window.location.pathname.split("/")[1] ==
                                "completedTrips"
                                ? 1
                                : 0.5,
                            width: "30px",
                          }}
                          className="ml-1"
                          src={CompleteTrip}
                          alt="route"
                        />
                      </div>
                      <div className="text-white ml-2 font-weight-bolder">
                        Completed Trip Report
                      </div>
                    </div>
                  )}

                  {gpsTrips && (
                    <div
                      className="navlink pl-4"
                      onClick={() => handleClick("tripslist")}
                    >
                      <div style={{ width: "20px" }}>
                        {" "}
                        <img
                          style={{
                            opacity:
                              window.location.pathname.split("/")[1] ==
                                "tripSchedulelist"
                                ? 1
                                : 0.5,
                            width: "30px",
                          }}
                          className="ml-1"
                          src={GPSdetail}
                          alt="route"
                        />
                      </div>
                      <div className="text-white ml-2 font-weight-bolder">
                        Gps Trips{" "}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
          {/* ==============================SUBMENU END======================================== */}

          {viewAllReportsSubMenuPermission?.length > 0 && (
            <div className="showDivReport">
              {permissionAccess?.companyId != "5" && (
                <>
                  {emergencyPerformanceReport && (
                    <div
                      className="text-white p- pl-4 navlink"
                      onClick={() =>
                        handleClick("reports?type=EMERGENCYPERFORMANCEREPORT")
                      }
                    >
                      <div style={{ width: "20px" }}>
                        {" "}
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] ==
                                "type=EMERGENCYPERFORMANCEREPORT"
                                ? 1
                                : 0.5,
                            width: "30px",
                          }}
                          src={emergencyIcon1}
                          alt="route"
                        />
                      </div>
                      <div className="text-white pl-3 font-weight-bolder">
                        Emergency Performance Report{" "}
                      </div>
                    </div>
                  )}

                  {agencyPerformanceReport && (
                    <div
                      className="text-white p- pl-4 navlink"
                      onClick={() =>
                        handleClick("reports?type=AGENCYPERFORMANCEREPORT")
                      }
                    >
                      <div style={{ width: "20px" }}>
                        {" "}
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] ==
                                "type=AGENCYPERFORMANCEREPORT"
                                ? 1
                                : 0.5,
                            width: "30px",
                          }}
                          src={agencyIcon}
                          alt="route"
                        />
                      </div>
                      <div className="text-white pl-3 font-weight-bolder">
                        {" "}
                        Agency Performance Report{" "}
                      </div>
                    </div>
                  )}

                  {tankerPerformanceReport && (
                    <div
                      className="text-white p-2 pl-4 navlink"
                      onClick={() =>
                        handleClick("reports?type=TANKERPERFORMANCEREPORT")
                      }
                    >
                      <div style={{ width: "20px" }}>
                        {" "}
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] ==
                                "type=TANKERPERFORMANCEREPORT"
                                ? 1
                                : 0.5,
                            width: "30px",
                          }}
                          src={tankerIcon}
                          alt="route"
                        />
                      </div>
                      <div className="text-white pl-3 font-weight-bolder">
                        {" "}
                        Tanker Performance Report{" "}
                      </div>
                    </div>
                  )}

                  {driverPerformanceReport && (
                    <div
                      className="text-white p-2 pl-4 navlink"
                      onClick={() =>
                        handleClick("reports?type=DRIVERPERFORMANCEREPORT")
                      }
                    >
                      <div style={{ width: "20px" }}>
                        {" "}
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] ==
                                "type=DRIVERPERFORMANCEREPORT"
                                ? 1
                                : 0.5,
                            width: "30px",
                          }}
                          src={DriverIcon}
                          alt="route"
                        />
                      </div>
                      <div className="text-white pl-3 font-weight-bolder">
                        {" "}
                        Driver Performance Report
                      </div>
                    </div>
                  )}

                  {penaltyReport && (
                    <div
                      className="text-white p-2 pl-4 navlink"
                      onClick={() => handleClick("penalty")}
                    >
                      <div style={{ width: "20px" }}>
                        {" "}
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] == "penalty"
                                ? 1
                                : 0.5,
                            width: "30px",
                          }}
                          src={palentyIcon}
                          alt="route"
                        />
                      </div>
                      <div className="text-white pl-3 font-weight-bolder">
                        {" "}
                        Penalty Report{" "}
                      </div>
                    </div>
                  )}

                  {tamperingReport && (
                    <div
                      className="text-white p-2 pl-4 navlink"
                      onClick={() => handleClick("reports?type=Tampering")}
                    >
                      <div style={{ width: "20px" }}>
                        {" "}
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] ==
                                "type=Tempering"
                                ? 1
                                : 0.5,
                            width: "30px",
                          }}
                          src={palentyIcon}
                          alt="route"
                        />
                      </div>
                      <div className="text-white pl-3 font-weight-bolder">
                        {" "}
                        Tampering Report{" "}
                      </div>
                    </div>
                  )}
                </>
              )}

              {inactiveVehicleReport && (
                <div
                  className="text-white p-2 pl-4 navlink"
                  onClick={() => handleClick("zeroDistance")}
                >
                  <div style={{ width: "20px" }}>
                    {" "}
                    <img
                      style={{
                        opacity:
                          window.location.search.split("?")[1] == "zeroDistance"
                            ? 1
                            : 0.5,
                        width: "30px",
                      }}
                      src={DriverIcon}
                      alt="route"
                    />
                  </div>
                  <div className="text-white pl-3 font-weight-bolder">
                    {" "}
                    Inactive Vehicle Report
                  </div>
                </div>
              )}

              {summaryReport && (
                <div
                  className="text-white p-2 pl-3 navlink"
                  onClick={() => handleClick("Summary")}
                >
                  <div style={{ width: "20px" }}>
                    {" "}
                    <img
                      style={{
                        opacity:
                          window.location.search.split("?")[1] == "type=Summary"
                            ? 1
                            : 0.5,
                        width: "35px",
                      }}
                      src={SummaryIcon}
                      alt="route"
                    />
                  </div>
                  <div className="text-white pl-3 font-weight-bolder">
                    {" "}
                    Summary Report{" "}
                  </div>
                </div>
              )}

              {permissionAccess?.companyId == "5" && (
                <div
                  className="text-white p-2 pl-3 navlink"
                  onClick={() => handleClick("DailyDistance")}
                >
                  <div style={{ width: "20px" }}>
                    {" "}
                    <img
                      style={{
                        opacity:
                          window.location.pathname.split("/")[1] ==
                            "DailyDistance"
                            ? 1
                            : 0.5,
                        width: "35px",
                      }}
                      src={SummaryIcon}
                      alt="route"
                    />
                  </div>
                  <div className="text-white pl-3 font-weight-bolder">
                    Distance Report{" "}
                  </div>
                </div>
              )}

              {permissionAccess?.companyId != "5" && gpsReport && (
                <div
                  className="text-white p-2 pl-4 navlink"
                  onClick={() => handleClick("reportsgps")}
                >
                  <div style={{ width: "20px" }}>
                    {" "}
                    <img
                      style={{
                        opacity:
                          window.location.pathname?.split("/")[1] ==
                            "reportsgps"
                            ? 1
                            : 0.5,
                      }}
                      src={GpsIcon}
                      alt="route"
                    />
                  </div>
                  <div className="text-white pl-2 font-weight-bolder">
                    GPS Report{" "}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* <div className="showDivFuel">
              <div
                className="text-white p-2 pl-4 navlink"
                onClick={() => handleClick("fuelDashboard")}
              >
                <div style={{ width: "20px" }}>
                  {" "}
                  <img
                    style={{
                      opacity:
                        window.location.search.split("?")[1] ==
                        "type=fuelDashboard"
                          ? 1
                          : 0.5,
                    }}
                    src={fuelDashboardIcon}
                    alt="route"
                  />
                </div>
                <div className="text-white pl-2 font-weight-bolder">
                  {" "}
                  Dashboard{" "}
                </div>
              </div>
              <div
                className="text-white p-2 pl-4 navlink"
                onClick={() => handleClick("fuelreport?type=FUELSUMMARY")}
              >
                <div style={{ width: "20px" }}>
                  <img
                    style={{
                      opacity:
                        window.location.search.split("?")[1] ==
                        "type=FUELSUMMARY"
                          ? 1
                          : 0.5,
                    }}
                    src={fuelFillIcon}
                    alt="route"
                  />
                </div>
                <div className="text-white pl-2 font-weight-bolder">
                  Fuel Summary Report{" "}
                </div>
              </div>
             

              <div
                className="text-white p-2 pl-4 navlink"
                onClick={() => handleClick("fuelreport?type=FUELFILL")}
              >
                <div style={{ width: "20px" }}>
                  {" "}
                  <img
                    style={{
                      opacity:
                        window.location.search.split("?")[1] == "type=FUELFILL"
                          ? 1
                          : 0.5,
                    }}
                    src={fuelFillIcon}
                    alt="route"
                  />
                </div>
                <div className="text-white pl-2 font-weight-bolder">
                  {" "}
                  Fuel Fill Report{" "}
                </div>
              </div>
              <div
                className="text-white p-2 pl-4 navlink"
                onClick={() => handleClick("fuelreport?type=FUELDROP")}
              >
                <div style={{ width: "20px" }}>
                  {" "}
                  <img
                    style={{
                      opacity:
                        window.location.search.split("?")[1] == "type=FUELDROP"
                          ? 1
                          : 0.5,
                    }}
                    src={fuelDroppageIcon}
                    alt="route"
                  />
                </div>
                <div className="text-white pl-2 font-weight-bolder">
                  {" "}
                  Fuel Droppage Report{" "}
                </div>
              </div>

              <div
                className="text-white p-2 pl-4 navlink"
                onClick={() => handleClick("fuelreport?type=FUELWIRECUT")}
              >
                <div style={{ width: "20px" }}>
                  <img
                    style={{
                      opacity:
                        window.location.search.split("?")[1] ==
                        "type=FUELWIRECUT"
                          ? 1
                          : 0.5,
                    }}
                    src={fuelFillIcon}
                    alt="route"
                  />
                </div>
                <div className="text-white pl-2 font-weight-bolder">
                  {" "}
                  Fuel Wirecut Report{" "}
                </div>
              </div>
              
            </div> */}

          {
            // (
            //   dataDecrypted.userType === "ADMIN" ||
            //   dataDecrypted?.designation === "DJB_USER"
            // )
            tokenManagement
            && (
              <div
                className="navlink"
                onClick={() => handleClick("token-management")}
              >
                <div style={{ width: "20px" }}>
                  <img
                    style={{
                      opacity:
                        window.location.pathname.split("/")[1] ===
                          "token-management"
                          ? 1
                          : 0.5,
                      width: "30px",
                    }}
                    className="ml-0 pl-1"
                    src={DriverIcon}
                    alt="site"
                  />
                </div>
                <div className="text-white ml-2 font-weight-bolder">
                  Token Management
                </div>
              </div>
            )}

          {viewAllReportPermission?.length > 0 && reportMenu && (
            <div className="navlink dropdown">
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "reportsgps" ||
                        window.location.pathname.split("/")[1] == "reports"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={reportIcon}
                  alt="route"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">Reports </div>
            </div>
          )}
          <div className="showDivReport">
            {permissionAccess?.companyId != "5" && (
              <>
                {/* suresh code */}
                {ShedInOutReport && (
                  <div
                    className="text-white p-2 pl-4 navlink"
                    onClick={() => handleClick("reports?type=ShedInOutReport")}
                  >
                    <div style={{ width: "20px" }}>
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                              "reports?type=ShedInOutReport"
                              ? 1
                              : 0.5,
                          width: "30px",
                        }}
                        src={palentyIcon}
                        alt="route"
                      />
                    </div>
                    <div className="text-white pl-3 font-weight-bolder">
                      {" "}
                      Shed IN/OUT Report{" "}
                    </div>
                  </div>
                )}
                {emergencyPerformanceReport && (
                  <div
                    className="text-white p- pl-4 navlink"
                    onClick={() =>
                      handleClick("reports?type=EMERGENCYPERFORMANCEREPORT")
                    }
                  >
                    <div style={{ width: "20px" }}>
                      {" "}
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                              "type=EMERGENCYPERFORMANCEREPORT"
                              ? 1
                              : 0.5,
                          width: "30px",
                        }}
                        src={emergencyIcon1}
                        alt="route"
                      />
                    </div>
                    <div className="text-white pl-3 font-weight-bolder">
                      Emergency Performance Report{" "}
                    </div>
                  </div>
                )}
                {inactiveVehicleReport && (
                  <div
                    className="text-white p- pl-4 navlink"
                    onClick={() =>
                      handleClick("reports?type=INACTIVEVEHICLEREPORT")
                    }
                  >
                    <div style={{ width: "20px" }}>
                      {" "}
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                              "type=INACTIVEVEHICLEREPORT"
                              ? 1
                              : 0.5,
                          width: "30px",
                        }}
                        src={emergencyIcon1}
                        alt="route"
                      />
                    </div>
                    <div className="text-white pl-3 font-weight-bolder">
                      Inactive Vehicle Report{" "}
                    </div>
                  </div>
                )}
                {agencyPerformanceReport && (
                  <div
                    className="text-white p- pl-4 navlink"
                    onClick={() =>
                      handleClick("reports?type=AGENCYPERFORMANCEREPORT")
                    }
                  >
                    <div style={{ width: "20px" }}>
                      {" "}
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                              "type=AGENCYPERFORMANCEREPORT"
                              ? 1
                              : 0.5,
                          width: "30px",
                        }}
                        src={agencyIcon}
                        alt="route"
                      />
                    </div>
                    <div className="text-white pl-3 font-weight-bolder">
                      {" "}
                      Agency Performance Report{" "}
                    </div>
                  </div>
                )}
                {tankerPerformanceReport && (
                  <div
                    className="text-white p-2 pl-4 navlink"
                    onClick={() =>
                      handleClick("reports?type=TANKERPERFORMANCEREPORT")
                    }
                  >
                    <div style={{ width: "20px" }}>
                      {" "}
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                              "type=TANKERPERFORMANCEREPORT"
                              ? 1
                              : 0.5,
                          width: "30px",
                        }}
                        src={tankerIcon}
                        alt="route"
                      />
                    </div>
                    <div className="text-white pl-3 font-weight-bolder">
                      {" "}
                      Tanker Performance Report{" "}
                    </div>
                  </div>
                )}
                {/* <div className='text-white p-2 pl-4 navlink' onClick={() => handleClick('reports?type=EMERGENCYCONSOLIDATEDPERFORMANCEREPORT')} >

                    <div style={{ width: '20px' }}>   <img style={{ opacity: window.location.search.split("?")[1] == 'type=EMERGENCYCONSOLIDATEDPERFORMANCEREPORT' ? 1 : 0.5,width: '30px' }} src={SummaryIcon} alt='route' />
                    </div>
                    <div className='text-white pl-3 font-weight-bolder'> Tanker Trip Performance Report </div>

                    </div> */}
                {driverPerformanceReport && (
                  <div
                    className="text-white p-2 pl-4 navlink"
                    onClick={() =>
                      handleClick("reports?type=DRIVERPERFORMANCEREPORT")
                    }
                  >
                    <div style={{ width: "20px" }}>
                      {" "}
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                              "type=DRIVERPERFORMANCEREPORT"
                              ? 1
                              : 0.5,
                          width: "30px",
                        }}
                        src={DriverIcon}
                        alt="route"
                      />
                    </div>
                    <div className="text-white pl-3 font-weight-bolder">
                      {" "}
                      Driver Performance Report
                    </div>
                  </div>
                )}
                {penaltyReport && (
                  <div
                    className="text-white p-2 pl-4 navlink"
                    onClick={() => handleClick("penalty")}
                  >
                    <div style={{ width: "20px" }}>
                      {" "}
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] == "penalty"
                              ? 1
                              : 0.5,
                          width: "30px",
                        }}
                        src={palentyIcon}
                        alt="route"
                      />
                    </div>
                    <div className="text-white pl-3 font-weight-bolder">
                      {" "}
                      Penalty Report{" "}
                    </div>
                  </div>
                )}

                {tamperingReport && (
                  <div
                    className="text-white p-2 pl-4 navlink"
                    onClick={() => handleClick("reports?type=Tampering")}
                  >
                    <div style={{ width: "20px" }}>
                      {" "}
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                              "type=Tempering"
                              ? 1
                              : 0.5,
                          width: "30px",
                        }}
                        src={palentyIcon}
                        alt="route"
                      />
                    </div>
                    <div className="text-white pl-3 font-weight-bolder">
                      {" "}
                      Tampering Report{" "}
                    </div>
                  </div>
                )}
              </>
            )}
            {summaryReport && (
              <div
                className="text-white p-2 pl-3 navlink"
                onClick={() => handleClick("Summary")}
              >
                <div style={{ width: "20px" }}>
                  {" "}
                  <img
                    style={{
                      opacity:
                        window.location.search.split("?")[1] == "type=Summary"
                          ? 1
                          : 0.5,
                      width: "35px",
                    }}
                    src={SummaryIcon}
                    alt="route"
                  />
                </div>
                <div className="text-white pl-3 font-weight-bolder">
                  {" "}
                  Summary Report{" "}
                </div>
              </div>
            )}

            {dataDecrypted.userType === "ADMIN" && logReport && (
              <div
                className="text-white p-2 pl-3 navlink"
                onClick={() => handleClick("Logs")}
              >
                <div style={{ width: "20px" }}>
                  {" "}
                  <img
                    style={{
                      opacity:
                        window.location.search.split("?")[1] == "type=Logs"
                          ? 1
                          : 0.5,
                      width: "35px",
                    }}
                    src={SummaryIcon}
                    alt="route"
                  />
                </div>
                <div className="text-white pl-3 font-weight-bolder">
                  {" "}
                  Log Report{" "}
                </div>
              </div>
            )}

            {dataDecrypted.userType === "ADMIN" && (
              <div
                className="text-white p-2 pl-3 navlink"
                onClick={() => handleClick("GPSTrailImport")}
              >
                <div style={{ width: "20px" }}>
                  {" "}
                  <img
                    style={{
                      opacity:
                        window.location.search.split("?")[1] ==
                          "type=GPSTrailImport"
                          ? 1
                          : 0.5,
                      width: "35px",
                    }}
                    src={SummaryIcon}
                    alt="route"
                  />
                </div>
                <div className="text-white pl-3 font-weight-bolder">
                  {" "}
                  GPS Trail Import
                </div>
              </div>
            )}

            {permissionAccess?.companyId == "5" && distanceReport && (
              <div
                className="text-white p-2 pl-3 navlink"
                onClick={() => handleClick("DailyDistance")}
              >
                <div style={{ width: "20px" }}>
                  {" "}
                  <img
                    style={{
                      opacity:
                        window.location.pathname.split("/")[1] ==
                          "DailyDistance"
                          ? 1
                          : 0.5,
                      width: "35px",
                    }}
                    src={SummaryIcon}
                    alt="route"
                  />
                </div>
                <div className="text-white pl-3 font-weight-bolder">
                  Distance Report{" "}
                </div>
              </div>
            )}

            {permissionAccess?.companyId == "5" && DisengargedDailyReports && (
              <div
                className="text-white p-2 pl-3 navlink"
                onClick={() => handleClick("DisengagedDaily")}
              >
                <div style={{ width: "20px" }}>
                  {" "}
                  <img
                    style={{
                      opacity:
                        window.location.pathname.split("/")[1] ==
                          "DisengagedDaily"
                          ? 1
                          : 0.5,
                      width: "35px",
                    }}
                    src={SummaryIcon}
                    alt="route"
                  />
                </div>
                <div className="text-white pl-3 font-weight-bolder">
                  Disengaged Daily Reports{" "}
                </div>
              </div>
            )}
            {duplicateReports && (
              <div
                className="text-white p-2 pl-3 navlink"
                onClick={() => handleClick("duplicate")}
              >
                <div style={{ width: "20px" }}>
                  {" "}
                  <img
                    style={{
                      opacity:
                        window.location.search.split("?")[1] == "type=duplicate"
                          ? 1
                          : 0.5,
                      width: "35px",
                    }}
                    src={SummaryIcon}
                    alt="route"
                  />
                </div>
                <div className="text-white pl-3 font-weight-bolder">
                  {" "}
                  Duplicate Report{" "}
                </div>
              </div>
            )}

            {permissionAccess?.companyId == "1" && (
              <div
                className="text-white p-2 pl-3 navlink"
                onClick={() => handleClick("ScheduleDistance")}
              >
                <div style={{ width: "20px" }}>
                  {" "}
                  <img
                    style={{
                      opacity:
                        window.location.pathname.split("/")[1] ==
                          "ScheduleDistance"
                          ? 1
                          : 0.5,
                      width: "35px",
                    }}
                    src={SummaryIcon}
                    alt="route"
                  />
                </div>
                <div className="text-white pl-3 font-weight-bolder">
                  Schedule Distance Report{" "}
                </div>
              </div>
            )}
            {permissionAccess?.companyId != "5" && (
              <div
                className="text-white p-2 pl-4 navlink"
                onClick={() => handleClick("reportsgps")}
              >
                <div style={{ width: "20px" }}>
                  {" "}
                  <img
                    style={{
                      opacity:
                        window.location.pathname.split("/")[1] == "reportsgps"
                          ? 1
                          : 0.5,
                    }}
                    src={GpsIcon}
                    alt="route"
                  />
                </div>
                <div className="text-white pl-2 font-weight-bolder">
                  GPS Report{" "}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <>
          <div className="navlink " onClick={() => handleClick("vehiclelist")}>
            <div style={{ width: "20px" }}>
              {" "}
              <img
                style={{
                  opacity:
                    window.location.pathname.split("/")[1] == "vehiclelist"
                      ? 1
                      : 0.5,
                  width: "30px",
                }}
                className="ml-1"
                src={carIcon}
                alt="vehicle"
              />
            </div>
            <div className="text-white ml-2 font-weight-bolder">
              {/* {vehicleName} Management{" "} */}
              {safeString(vehicleName)} Management
            </div>
          </div>

          <div
            className="navlink "
            onClick={() => handleClick("preApprovalList")}
          >
            <div style={{ width: "20px" }}>
              {" "}
              <img
                style={{
                  opacity:
                    window.location.pathname.split("/")[1] == "preApprovalList"
                      ? 1
                      : 0.5,
                  width: "30px",
                }}
                className="ml-1"
                src={tripIcon}
                alt="route"
              />
            </div>
            <div className="text-white ml-2 font-weight-bolder">
              Prior Trip Management{" "}
            </div>
          </div>

          <div className="navlink dropdown">
            <div style={{ width: "20px" }}>
              {" "}
              <img
                style={{
                  opacity:
                    window.location.pathname.split("/")[1] == "tripStatus"
                      ? 1
                      : 0.5,
                  width: "30px",
                }}
                className="ml-1"
                src={tripIcon}
                alt="route"
              />
            </div>
            <div className="text-white ml-2 font-weight-bolder">
              Trip Management{" "}
            </div>
          </div>

          <div className="showDivReport1">
            <div
              className="navlink pl-4"
              onClick={() => handleClick("tripStatus")}
            >
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "tripStatus"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={tripdashboard}
                  alt="route"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Trip Dashboard{" "}
              </div>
            </div>

            {/* <div className='navlink pl-4' onClick={() => handleClick('tripSchedulelist')}>
            <div style={{ width: '20px' }}>   <img style={{ opacity: window.location.pathname.split("/")[1] == 'tripSchedulelist' ? 1 : 0.5,width:'30px' }} className='ml-1' src={tripschedule} alt='route' />
            </div>
            <div className='text-white ml-2 font-weight-bolder'>Trip Allocation Report </div>

        </div> */}
            <div
              className="navlink pl-4"
              onClick={() => handleClick("missedTripApproval")}
            >
              <div style={{ width: "20px" }}>
                {" "}
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ==
                        "missedTripApproval"
                        ? 1
                        : 0.5,
                    width: "30px",
                  }}
                  className="ml-1"
                  src={MissedApprovalTrip}
                  alt="route"
                />
              </div>
              <div className="text-white ml-2 font-weight-bolder">
                Missed Trip Approval
              </div>
            </div>
            {/* <div className='navlink pl-4' onClick={() => handleClick('missedTrips')}>
            <div style={{ width: '20px' }}>   <img style={{ opacity: window.location.pathname.split("/")[1] == 'missedTrips' ? 1 : 0.5,width: '30px' }} className='ml-1' src={MissedTrip} alt='route' />
            </div>
            <div className='text-white ml-2 font-weight-bolder'>Missed Trip Report</div>

        </div> */}

            {/* <div className='navlink pl-4' onClick={() => handleClick('completedTrips')}>
            <div style={{ width: '20px' }}>   <img style={{ opacity: window.location.pathname.split("/")[1] == 'completedTrips' ? 1 : 0.5,width: '30px' }} className='ml-1' src={CompleteTrip} alt='route' />
            </div>
            <div className='text-white ml-2 font-weight-bolder'>Completed Trip Report</div>

        </div> */}

            {/* <div className='navlink pl-4' onClick={() => handleClick('tripslist')}>
            <div style={{ width: '20px' }}>   <img style={{ opacity: window.location.pathname.split("/")[1] == 'tripSchedulelist' ? 1 : 0.5,width:'30px' }} className='ml-1' src={GPSdetail} alt='route' />
            </div>
            <div className='text-white ml-2 font-weight-bolder'>Gps Trips </div>

        </div> */}
          </div>
        </>
      )}

      {emailDecrypted === "route" && (
        <div className="navlink " onClick={() => handleClick("routelist")}>
          <div style={{ width: "20px" }}>
            {" "}
            <img
              style={{
                opacity:
                  window.location.pathname.split("/")[1] == "routelist"
                    ? 1
                    : 0.5,
              }}
              className="ml-1"
              src={routeIcon}
              alt="route"
            />
          </div>
          <div className="text-white ml-2 font-weight-bolder">
            Route Management{" "}
          </div>
        </div>
      )}
    </div>
  );
}

export default Sidebar;
